import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import FlyoutModal from '../common/FlyoutModal';
import messages from './messages';
import styles from './WhatIsThisFee.module.scss';

const WhatIsThisFee = () => {
  const { formatMessage } = useIntl();
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <>
      {isModalOpen && (
        <FlyoutModal
          isVisible={isModalOpen}
          onCloseModal={() => setModalOpen(false)}
          backButtonLabel={formatMessage(messages.buttonBackLabel)}
        >
          <div className={styles['modal-title']}>
            {formatMessage(messages.recyclingFeeModalTitle)}
          </div>

          <div className={styles['paragraph-title']}>
            {formatMessage(messages.paragraphTitle01)}
          </div>
          <div className={styles['paragraph-content']}>
            {formatMessage(messages.paragraphContent01)}
          </div>

          <div className={styles['paragraph-title']}>
            {formatMessage(messages.paragraphTitle02)}
          </div>
          <div className={styles['paragraph-content']}>
            {formatMessage(messages.paragraphContent02)}
          </div>

          <div className={styles['paragraph-title']}>
            {formatMessage(messages.paragraphTitle03)}
          </div>
          <div className={styles['paragraph-content']}>
            {formatMessage(messages.paragraphContent03)}
          </div>

          <div className={styles['paragraph-title']}>
            {formatMessage(messages.paragraphTitle04)}
          </div>
          <div className={styles['paragraph-content']}>
            {formatMessage(messages.paragraphContent04)}
          </div>

          <div className={styles['paragraph-title']}>
            {formatMessage(messages.paragraphOregonTitle)}
          </div>
          <div className={styles['paragraph-content']}>
            {formatMessage(messages.paragraphOregonContent)}
          </div>
        </FlyoutModal>
      )}

      <div
        onClick={() => setModalOpen(true)}
        role="button"
        tabIndex={-1}
        onKeyDown={() => {}}
        className={styles['price-breakdown-recycling-fee-what']}
      >
        {formatMessage(messages.priceBreakdownRecyclingFeeWhatIsThis)}
      </div>
    </>
  );
};

export default WhatIsThisFee;
